import { useContext, useState, useCallback } from 'react';

import { NotificationContext } from '../../App';
import { updatePassword } from '../../requests/requests';
import { SnackbarType, ButtonType, InputType } from '../../types/enums';
import { isPasswordAcceptable } from '../../utils/common';
import Button from '../Button/Button';
import Input from '../Input/Input';
import useErrorHandler from '../../hooks/useErrorHandler';

const UpdatePassword = () => {
  const notify = useContext(NotificationContext);
  const errorHandler = useErrorHandler();

  const [oldPassword, setOldPassword] = useState('');
  const [password, setPassword] = useState('');
  const [pwError, setPwError] = useState(false);

  const onSubmit = useCallback(
    (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();

      setPwError(false);

      if (!isPasswordAcceptable(password)) {
        setPwError(true);
      }

      if (isPasswordAcceptable(password)) {
        updatePassword(password, oldPassword).then(() => {
          notify('Your password has been updated!', SnackbarType.SUCCESS);
        }, errorHandler);
      }
    },
    [password, oldPassword]
  );

  return (
    <div style={{'marginBottom': '2rem'}}>
      <p>
        <strong>Password:</strong>
        <br />
        You can renew your password here.
      </p>
      <form onSubmit={onSubmit}>
        <Input
          type={InputType.PASSWORD}
          id="currentPassword"
          label="Current Password:"
          setValue={setOldPassword}
          value={oldPassword}
          placeholder="Your current Password"
        />
        <Input
          type={InputType.PASSWORD}
          id="password"
          label="New Password:"
          setValue={setPassword}
          value={password}
          placeholder="Your new password"
          error={pwError ? 'Minimum 8 characters required.' : ''}
        />
        <Button type={ButtonType.PRIMARY} isSubmit>
          SAVE PASSWORD
        </Button>
      </form>
    </div>
  );
};

export default UpdatePassword;
